/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdherenceReportRangeDto } from './AdherenceReportRangeDto';
import {
    AdherenceReportRangeDtoFromJSON,
    AdherenceReportRangeDtoFromJSONTyped,
    AdherenceReportRangeDtoToJSON,
    AdherenceReportRangeDtoToJSONTyped,
} from './AdherenceReportRangeDto';
import type { DailyAdherenceScoreDto } from './DailyAdherenceScoreDto';
import {
    DailyAdherenceScoreDtoFromJSON,
    DailyAdherenceScoreDtoFromJSONTyped,
    DailyAdherenceScoreDtoToJSON,
    DailyAdherenceScoreDtoToJSONTyped,
} from './DailyAdherenceScoreDto';
import type { DailyTaskSlotDto } from './DailyTaskSlotDto';
import {
    DailyTaskSlotDtoFromJSON,
    DailyTaskSlotDtoFromJSONTyped,
    DailyTaskSlotDtoToJSON,
    DailyTaskSlotDtoToJSONTyped,
} from './DailyTaskSlotDto';
import type { TodayPillarDto } from './TodayPillarDto';
import {
    TodayPillarDtoFromJSON,
    TodayPillarDtoFromJSONTyped,
    TodayPillarDtoToJSON,
    TodayPillarDtoToJSONTyped,
} from './TodayPillarDto';

/**
 * 
 * @export
 * @interface AdherenceReportResponseDto
 */
export interface AdherenceReportResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AdherenceReportResponseDto
     */
    period: AdherenceReportResponseDtoPeriodEnum;
    /**
     * 
     * @type {string}
     * @memberof AdherenceReportResponseDto
     */
    timezone: string;
    /**
     * 
     * @type {AdherenceReportRangeDto}
     * @memberof AdherenceReportResponseDto
     */
    range: AdherenceReportRangeDto;
    /**
     * 
     * @type {number}
     * @memberof AdherenceReportResponseDto
     */
    averagePercentage: number | null;
    /**
     * 
     * @type {Array<DailyAdherenceScoreDto>}
     * @memberof AdherenceReportResponseDto
     */
    days: Array<DailyAdherenceScoreDto>;
    /**
     * Populated for the daily view; empty for trend views
     * @type {Array<TodayPillarDto>}
     * @memberof AdherenceReportResponseDto
     */
    pillars: Array<TodayPillarDto>;
    /**
     * Populated for the daily view; empty for trend views
     * @type {Array<DailyTaskSlotDto>}
     * @memberof AdherenceReportResponseDto
     */
    slots: Array<DailyTaskSlotDto>;
}


/**
 * @export
 */
export const AdherenceReportResponseDtoPeriodEnum = {
    Daily: 'daily',
    Weekly: 'weekly',
    Monthly: 'monthly'
} as const;
export type AdherenceReportResponseDtoPeriodEnum = typeof AdherenceReportResponseDtoPeriodEnum[keyof typeof AdherenceReportResponseDtoPeriodEnum];


/**
 * Check if a given object implements the AdherenceReportResponseDto interface.
 */
export function instanceOfAdherenceReportResponseDto(value: object): value is AdherenceReportResponseDto {
    if (!('period' in value) || value['period'] === undefined) return false;
    if (!('timezone' in value) || value['timezone'] === undefined) return false;
    if (!('range' in value) || value['range'] === undefined) return false;
    if (!('averagePercentage' in value) || value['averagePercentage'] === undefined) return false;
    if (!('days' in value) || value['days'] === undefined) return false;
    if (!('pillars' in value) || value['pillars'] === undefined) return false;
    if (!('slots' in value) || value['slots'] === undefined) return false;
    return true;
}

export function AdherenceReportResponseDtoFromJSON(json: any): AdherenceReportResponseDto {
    return AdherenceReportResponseDtoFromJSONTyped(json, false);
}

export function AdherenceReportResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdherenceReportResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'period': json['period'],
        'timezone': json['timezone'],
        'range': AdherenceReportRangeDtoFromJSON(json['range']),
        'averagePercentage': json['averagePercentage'],
        'days': ((json['days'] as Array<any>).map(DailyAdherenceScoreDtoFromJSON)),
        'pillars': ((json['pillars'] as Array<any>).map(TodayPillarDtoFromJSON)),
        'slots': ((json['slots'] as Array<any>).map(DailyTaskSlotDtoFromJSON)),
    };
}

export function AdherenceReportResponseDtoToJSON(json: any): AdherenceReportResponseDto {
    return AdherenceReportResponseDtoToJSONTyped(json, false);
}

export function AdherenceReportResponseDtoToJSONTyped(value?: AdherenceReportResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'period': value['period'],
        'timezone': value['timezone'],
        'range': AdherenceReportRangeDtoToJSON(value['range']),
        'averagePercentage': value['averagePercentage'],
        'days': ((value['days'] as Array<any>).map(DailyAdherenceScoreDtoToJSON)),
        'pillars': ((value['pillars'] as Array<any>).map(TodayPillarDtoToJSON)),
        'slots': ((value['slots'] as Array<any>).map(DailyTaskSlotDtoToJSON)),
    };
}

